import React from "react";
import Topbar from "./Topbar";
import Footer from "./Footer";
import Menu from "./Menu";
import PlanExpireBanner from "src/components/dashboard/PlanExpireBanner";

interface LayoutProps {
  children: React.ReactNode;
  type?: "admin" | "tenant";
  meta?: {
    title?: string;
    description?: string;
    keywords?: string;
  };
}

const Layout: React.FC<LayoutProps> = ({ children, type = "tenant" }) => {
  return (
    <div className="h-screen flex flex-col">
      {/* Top bar */}
      <Topbar type={type} />
      <PlanExpireBanner type={type} />

      {/* Main content */}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        <aside className="hidden md:block bg-white w-64 border-r border-gray-300">
          <Menu type={type} />
        </aside>
        <main className="flex-1 min-h-0 overflow-y-scroll flex flex-col justify-between">
          <div className="p-4">{children}</div>

          {/* Footer */}
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default Layout;
